import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import AppErrorBoundary from './components/AppErrorBoundary';
import { initializeOpenAIAdPixel, measureCompletedSignup } from './utils/openaiAdPixel';

initializeOpenAIAdPixel();
measureCompletedSignup();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(



  <React.StrictMode>

    <GoogleOAuthProvider clientId="377399520693-2fak6nmevi6o5sa8viearqs1einc9dcl.apps.googleusercontent.com">
    <AppErrorBoundary><App /></AppErrorBoundary>
    </GoogleOAuthProvider>

  </React.StrictMode>

);

reportWebVitals();
